import React, { useState, useRef, useEffect } from 'react'
import coverPhotoContImage from '../Images/default-cover.gif'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import swal from 'sweetalert';
import Alert from 'react-bootstrap/Alert';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';


// firebase
import {db, storage} from '../firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, query, getDocs, where } from "firebase/firestore";
import { doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

//routers
import {useNavigate } from "react-router-dom";




function EditAccountComp() {

  //states
  const [loggedInUser, setLoggedInUser] = useState("");
  const [userNationality, setNationality] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [userUid, setUserUid] = useState("");

    //states
    const [userEmail, setUserEmail] = useState("");
    const [userPhone, setUserPhone] = useState("");
    const [userWebsite, setUserWebsite] = useState("");
    const [userAbout, setUserAbout] = useState("");
    const [userExpectation, setUserExpectation] = useState("");
    const [userCourse, setUserCourse] = useState("");
    const [userSessionTime, setUserSessionTime] = useState("");
    const [userClassType, setUserClassType] = useState("");
  
  
    //update user state
    const [updateUserWebsite, setUpdateUserWebsite] = useState("");
    const [updateUserGithub, setUserGithub] = useState("");
    const [updateInstitutionName, setInstitutionName] = useState("");
    const [updateEducationLevel,setEducationLevel] = useState("");

      //get data from input
  const educationRef = useRef();
  const institutionRef = useRef();
  const phoneRef = useRef();
  const githubRef = useRef();
  const websiteRef = useRef();
  const aboutMeRef = useRef();
  const expectationsRef = useRef();


  const [userProfilePicture, setProfilePicture] = useState("");
  const [userCoverPicture, setCoverPicture] = useState("");
  const [showProfileAlert, setShowProfileAlert] = useState(false);
  const [showCoverAlert, setShowCoverAlert] = useState(false);
  const [profileUploadBtn, setProfileUploadBtn] = useState("Upload");
  const [coverUploadBtn, setCoverUploadBtn] = useState("Upload");
  const [profileUploadProgress, setProfileUploadProgress] = useState(0);
  const [coverUploadProgress, setCoverUploadProgress] = useState(0);
  const [profileUploadStatus, setProfileUploadStatus] = useState("Uploading...0%");
  const [coverUploadStatus, setCoverUploadStatus] = useState("Uploading...0%");
  const profilePreviewRef = useRef(false);
  const coverPreviewRef = useRef(false);
  const profilePreviewUrlRef = useRef("");
  const coverPreviewUrlRef = useRef("");



  //use ref
  const fileInput = useRef();
  const coverInput = useRef();

  //instantiate aut
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
      //if user is logged in 
      const uid = user.uid;
      setUserUid(uid);
      setIsLoading(true);

      const q = query(collection(db, "users"), where("userId", "==", uid));
      getDocs(q).then((QuerySnapshot)=>{
          if (QuerySnapshot.empty) {
            setIsLoading(false);
            return;
          }
          QuerySnapshot.forEach((doc)=>{
          const username = doc.data().bio;
          const nationality = doc.data().nationality;
          const profilePic = doc.data().profilePic;
          const coverPhoto = doc.data().coverPhoto;

          const whyInterested = doc.data().whyInterested;
          const aboutMe = doc.data().aboutMe;
          const phoneNumber = doc.data().phoneNumber;
          const userEmail = doc.data().userEmail;
          const userWebsite = doc.data().userWebsite;
          const userGithub = doc.data().userGithub;
          const institutionName = doc.data().institutionName ?? doc.data().highSchoolMath;
          const educationLevel = doc.data().educationLevel;

          const course = doc.data().course;
          const sessionTime = doc.data().sessionTime;
          const classType = doc.data().classType;



          setUserEmail(userEmail);
          setUserPhone(phoneNumber);
          setUserWebsite(userWebsite);
          setUserAbout(aboutMe);
          setUserExpectation(whyInterested);

          setUserCourse(course);
          setUserSessionTime(sessionTime);
          setUserClassType(classType);

          //update
          setUpdateUserWebsite(userWebsite);
          setUserGithub(userGithub);
          setInstitutionName(institutionName);
          setEducationLevel(educationLevel);

          setLoggedInUser(username);
          setNationality(nationality);
          //setProfilePicture(profilePic);
          //setCoverPicture(coverPhoto);

          let myxx = profilePic + "1";
          let myYY = coverPhoto + "1";


          if(!profilePreviewRef.current){
            if(myxx === "undefined1"){
              setProfilePicture("");         
            }else{
              setProfilePicture(profilePic);
            }
          }

          //
          if(!coverPreviewRef.current){
            if(myYY === "undefined1"){
              setCoverPicture(coverPhotoContImage);
            }else{
              setCoverPicture(coverPhoto);
            }
          }

          })
          setIsLoading(false);
      })

          } else {
          // User is signed out
          setIsLoading(false);
          }
      });

    return () => unsubscribe();
  }, [auth]);

  const handleUpdateProfile = () => {
      if (!userUid) return;
      const educationValue = educationRef.current.value;
      const institutionValue = institutionRef.current.value;
      const phoneValue = phoneRef.current.value;
      const githubValue = githubRef.current.value;
      const websiteValue = websiteRef.current.value;
      const aboutMeValue = aboutMeRef.current.value;
      const expectationsValue = expectationsRef.current.value;

      updateDoc(doc(db, "users", userUid), {
          phoneNumber: phoneValue,
          educationLevel:educationValue,
          institutionName: institutionValue,
          highSchoolMath: institutionValue,
          userGithub:githubValue,
          userWebsite: websiteValue,
          aboutMe:aboutMeValue,
          whyInterested:expectationsValue
      }).then(()=>{
          swal("Success", "Profile updated successfully!", "success");
      });
  };

  const handleSaveProfilePhoto = () => {
      if (!userUid) return;
      const profilePhoto = fileInput.current?.files?.[0];
      if (!profilePhoto) {
          swal("Select a photo", "Please choose a profile picture to upload.", "warning");
          return;
      }

      if (!storage) {
          swal("Storage error", "Unable to connect to storage. Please refresh and try again.", "error");
          return;
      }

      const storageRef = ref(storage, `images/${Date.now()}_${profilePhoto.name}`);
      const uploadTask = uploadBytesResumable(storageRef, profilePhoto);

      uploadTask.on('state_changed', 
          (snapshot) => {
              setShowProfileAlert(true);              
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              const roundedOffProgress = Math.round(progress);

              setProfileUploadProgress(roundedOffProgress);
              setProfileUploadStatus('Upload is ' + roundedOffProgress + '% done');
              setProfileUploadBtn("Uploading.."+roundedOffProgress +'%')
              
          }, 
      (error) => {
          console.error("Profile upload error:", error);
      }, 
      () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              updateDoc(doc(db, "users", userUid), {
                  profilePic: downloadURL
              }).then(()=>{
                  setProfilePicture(downloadURL);
                  setProfileUploadBtn("Uploaded");
                  setShowProfileAlert(false);
                  swal("Success", "Profile picture updated successfully!", "success");
              })  
          });
      }
      );
  };

  const handleSaveCoverPhoto = () => {
      if (!userUid) return;
      const coverPhoto = coverInput.current?.files?.[0];
      if (!coverPhoto) {
          swal("Select a photo", "Please choose a cover photo to upload.", "warning");
          return;
      }

      if (!storage) {
          swal("Storage error", "Unable to connect to storage. Please refresh and try again.", "error");
          return;
      }

      const storageRef = ref(storage, `images/${Date.now()}_${coverPhoto.name}`);
      const uploadTask = uploadBytesResumable(storageRef, coverPhoto);

      uploadTask.on('state_changed', 
          (snapshot) => {
              setShowCoverAlert(true);              
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              const roundedOffProgress = Math.round(progress);

              setCoverUploadProgress(roundedOffProgress);
              setCoverUploadStatus('Upload is ' + roundedOffProgress + '% done');
              setCoverUploadBtn("Uploading.."+roundedOffProgress +'%')
              
          }, 
      (error) => {
          console.error("Cover upload error:", error);
      }, 
      () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              updateDoc(doc(db, "users", userUid), {
                  coverPhoto: downloadURL
              }).then(()=>{
                  setCoverPicture(downloadURL);
                  setCoverUploadBtn("Uploaded");
                  setShowCoverAlert(false);
                  swal("Success", "Cover photo updated successfully!", "success");
              })  
          });
      }
      );
  };

  useEffect(() => {
    return () => {
      if (profilePreviewUrlRef.current) {
        URL.revokeObjectURL(profilePreviewUrlRef.current);
      }
      if (coverPreviewUrlRef.current) {
        URL.revokeObjectURL(coverPreviewUrlRef.current);
      }
    };
  }, []);

    //update profile picture on select
    function updateProfilePhoto(){
        const profilePhoto = fileInput.current.files[0];
        if (!profilePhoto) return;
        if (profilePreviewUrlRef.current) {
          URL.revokeObjectURL(profilePreviewUrlRef.current);
        }
        const url = URL.createObjectURL(profilePhoto);
        profilePreviewUrlRef.current = url;
        profilePreviewRef.current = true;
        setProfileUploadBtn("Upload");
        setShowProfileAlert(false);
        setProfileUploadProgress(0);
        setProfileUploadStatus("Uploading...0%");
        setProfilePicture(url)
    }

    //update profile picture on select
    function updateCoverPhoto(){
        const profilePhoto = coverInput.current.files[0];
        if (!profilePhoto) return;
        if (coverPreviewUrlRef.current) {
          URL.revokeObjectURL(coverPreviewUrlRef.current);
        }
        const url = URL.createObjectURL(profilePhoto);
        coverPreviewUrlRef.current = url;
        coverPreviewRef.current = true;
        setCoverUploadBtn("Upload");
        setShowCoverAlert(false);
        setCoverUploadProgress(0);
        setCoverUploadStatus("Uploading...0%");
        setCoverPicture(url)
    }

    //go to profile
    let navigate = useNavigate();
    function goToProfilePage(){
        navigate("/profile")
    }


  return (
    <div>
        <div className='editProfilePage'>
            {isLoading ? (
                <div className='editSkeleton'>
                    <div className='editSkeletonHero'>
                        <div className='editSkeletonCover'></div>
                        <div className='editSkeletonContent'>
                            <div className='editSkeletonAvatar'></div>
                            <div className='editSkeletonText'>
                                <div className='skeleton-line skeleton-line--title'></div>
                                <div className='skeleton-line'></div>
                                <div className='editSkeletonChips'>
                                    <div className='skeleton-pill'></div>
                                    <div className='skeleton-pill'></div>
                                    <div className='skeleton-pill'></div>
                                </div>
                            </div>
                            <div className='skeleton-button'></div>
                        </div>
                    </div>

                    <div className='editGrid'>
                        <div className='editCard editCardWide'>
                            <div className='skeleton-line skeleton-line--title'></div>
                            <div className='editSkeletonUploads'>
                                <div className='editSkeletonUploadCard'>
                                    <div className='skeleton-image'></div>
                                    <div className='skeleton-line'></div>
                                    <div className='skeleton-button'></div>
                                </div>
                                <div className='editSkeletonUploadCard'>
                                    <div className='skeleton-image'></div>
                                    <div className='skeleton-line'></div>
                                    <div className='skeleton-button'></div>
                                </div>
                            </div>
                        </div>

                        <div className='editCard'>
                            <div className='skeleton-line skeleton-line--title'></div>
                            <div className='editSkeletonFields'>
                                <div className='skeleton-line'></div>
                                <div className='skeleton-line'></div>
                            </div>
                        </div>

                        <div className='editCard'>
                            <div className='skeleton-line skeleton-line--title'></div>
                            <div className='editSkeletonFields'>
                                <div className='skeleton-line'></div>
                                <div className='skeleton-line'></div>
                            </div>
                        </div>

                        <div className='editCard editCardWide'>
                            <div className='skeleton-line skeleton-line--title'></div>
                            <div className='editSkeletonFields'>
                                <div className='skeleton-line'></div>
                                <div className='skeleton-line'></div>
                            </div>
                            <div className='editSkeletonActions'>
                                <div className='skeleton-button'></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
            <>
            <div className='editHero'>
                <div className='editHeroCover'>
                    <img src={userCoverPicture} alt="" />
                </div>
                <div className='editHeroOverlay'></div>
                <div className='editHeroContent'>
                    <div className='editHeroAvatar'>
                        <img src={userProfilePicture} alt="" />
                    </div>
                    <div className='editHeroText'>
                        <h3>{loggedInUser || "Your Profile"}</h3>
                        <p><FontAwesomeIcon icon={faMapMarkerAlt} className="profileLocationIcon"/> {userNationality || "Update your location"}</p>
                        <div className='editHeroChips'>
                            <span>{userCourse || "No course set"}</span>
                            <span>{userClassType || "Class type"}</span>
                            <span>{userSessionTime || "Session time"}</span>
                        </div>
                    </div>
                    <button className='editHeroBack' onClick={goToProfilePage}>
                        <FontAwesomeIcon icon={faArrowLeft} className="profileLocationIcon"/> Back to profile
                    </button>
                </div>
            </div>

            <div className='editGrid'>
                <div className='editCard editCardWide'>
                    <div className='editCardHeader'>
                        <h6>Profile Photos</h6>
                        <p>Update your profile picture and cover image.</p>
                    </div>
                    <div className='editUploadGrid'>
                        <div className='editUploadCard'>
                            <div className='editUploadPreview'>
                                <img src={userProfilePicture} alt="" />
                            </div>
                            <div>
                                <p>Profile Picture</p>
                                <div className='editUploadRow'>         
                                    <input type="file" ref={fileInput} className="form-control editInput" onChange={updateProfilePhoto}/>             
                                    <button className='editUploadButton' onClick={handleSaveProfilePhoto}>{profileUploadBtn}</button>
                                </div>
                                {showProfileAlert && 
                                    <Alert className='mt-3'>
                                        {profileUploadStatus}
                                        <ProgressBar striped variant="info" now={profileUploadProgress} />
                                    </Alert>
                                }
                            </div>
                        </div>

                        <div className='editUploadCard'>
                            <div className='editUploadPreview'>
                                <img src={userCoverPicture} alt="" />
                            </div>
                            <div>
                                <p>Cover Photo</p>
                                <div className='editUploadRow'>         
                                    <input type="file" ref={coverInput} className="form-control editInput" onChange={updateCoverPhoto}/>             
                                    <button className='editUploadButton' onClick={handleSaveCoverPhoto}>{coverUploadBtn}</button>
                                </div>
                                {showCoverAlert && 
                                    <Alert className='mt-3'>
                                        {coverUploadStatus}
                                        <ProgressBar striped variant="info" now={coverUploadProgress} />
                                    </Alert>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className='editCard'>
                    <div className='editCardHeader'>
                        <h6>Academic Background</h6>
                        <p>Let us know your latest education level.</p>
                    </div>
                    <div className='editFormGrid'>
                        <div className='editField'>
                            <label htmlFor="">Highest level of education</label>
                            <select name="" ref={educationRef} defaultValue={updateEducationLevel} className='form-control editInput'>
                                <option value="PhD">PhD</option>
                                <option value="Masters">Masters</option>
                                <option value="Bachelors Degree">Bachelors Degree</option>
                                <option value="High School">High School</option>
                            </select>
                        </div>

                        <div className='editField'>
                            <label htmlFor="">Institution name</label>
                            <input type="text" className='form-control editInput' ref={institutionRef} defaultValue={updateInstitutionName}  placeholder='eg University of Nairobi'/>
                        </div>
                    </div>
                </div>

                <div className='editCard'>
                    <div className='editCardHeader'>
                        <h6>Contact & Links</h6>
                        <p>Keep your profile links up to date.</p>
                    </div>
                    <div className='editFormGrid'>
                        <div className='editField'>
                            <label htmlFor="">Phone number</label>
                            <input type="text" className='form-control editInput'ref={phoneRef} defaultValue={userPhone} placeholder='eg +254'/>
                        </div>

                        <div className='editField'>
                            <label htmlFor="">Github Account Link</label>
                            <input type="text" className='form-control editInput' ref={githubRef} defaultValue={updateUserGithub} placeholder='https://github.com/user-name'/>
                        </div>

                        <div className='editField'>
                            <label htmlFor="">Portfolio website</label>
                            <input type="text" className='form-control editInput' ref={websiteRef} defaultValue={updateUserWebsite}  placeholder='www.example.me'/>
                        </div>
                    </div>
                </div>

                <div className='editCard editCardWide'>
                    <div className='editCardHeader'>
                        <h6>About & Goals</h6>
                        <p>Share a quick summary and your expectations.</p>
                    </div>
                    <div className='editFormGrid'>
                        <div className='editField'>
                            <label htmlFor="">About Me</label>
                            <textarea className='form-control editInput editTextarea' rows="4" ref={aboutMeRef} defaultValue={userAbout} ></textarea>
                        </div>
                        <div className='editField'>
                            <label htmlFor="">Why Im at Ubunifu</label>
                            <textarea className='form-control editInput editTextarea' ref={expectationsRef} defaultValue={userExpectation}  rows="4"></textarea>
                        </div>
                    </div>

                    <div className='editActions'>
                        <Button className='editPrimaryButton' onClick={handleUpdateProfile}>Update Info</Button>
                    </div>
                </div>

            </div>
            </>
            )}
        </div>
    </div>
  )
}

export default EditAccountComp



//mpesaNumber
